import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CalculatePayoutRequest, ClaimModel } from "../models/calculate-payment-request";
import { CalculatePaymentResponse } from "../models/calculate-payment-response";
import { ConditionModel } from "../models/condition.model";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: 'root'
})
export class MultiClaimCalculatorService {
  constructor(private api: ApiService) {

  }
  async calculatePayout(sumAssured: number, claims: ClaimModel[]): Promise<PayoutResult> {
    const selectedClaims = claims.filter(x => x.selected).map((x, i) => { x.claimRef = `${i}`; return x; });
    const request: CalculatePayoutRequest = {
      sumAssured: sumAssured,
      claims: selectedClaims
    }
    const ret = await this.api.calculatePayout(request);
    return { ...ret, sumAssured };
  }

  listConditions$(): Observable<ConditionModel[]> {
    return this.api.getConditions();
  }
}

export class PayoutResult extends CalculatePaymentResponse {
  sumAssured: number;
}
